import { create } from 'zustand';
import { SOTERIA_AGENT } from '../agentKind';
import type { AgentKind } from '../agentKind';

/**
 * sidePanelStore
 * --------------
 * Controls the right-side Soteria drawer triggered by the Sparkles icon
 * in the top header. Lives outside the Soteria feature so any component
 * (header, sidebar, in-app shortcut) can open the panel without prop-
 * drilling a callback through the entire tree.
 *
 * `kind` records which agent the drawer is showing. There is only one
 * user-facing assistant now (`soteria`, a supervisor that routes each turn to
 * a specialist), so this no longer depends on the route — which also fixes the
 * drawer keeping a stale agent when you navigated with it open.
 *
 * Persistence is in-memory only — refreshing the app should NOT re-open
 * the panel; users expect a clean page on load.
 */
interface SoteriaSidePanelStore {
  isOpen: boolean;
  kind: AgentKind;
  /** Open the drawer showing a specific agent kind. */
  openFor: (kind: AgentKind) => void;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useSoteriaSidePanelStore = create<SoteriaSidePanelStore>((set) => ({
  isOpen: false,
  kind: SOTERIA_AGENT,
  openFor: (kind) => set({ isOpen: true, kind }),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
